module.exports = __webpack_public_path__ + "img/login4.b4cb2cdd.gif";